import Header from "../header/Header";
import Footer from "../footer/Footer";
import BottomNav from "../navigation/BottomNav";
import NewsletterPopover from "../NewsletterPopover";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import React from 'react';
import SEOHead from '../seo/SEOHead';
import { organizationSchema } from '../seo/JsonLd';

function Layout({ toggleTheme, children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="layout min-h-screen flex flex-col theme-transition">
      <SEOHead
        title="Start Your Calisthenics Journey"
        description="India's premier calisthenics and bodyweight strength training platform. Expert-led programs, live coaching, and a thriving fitness community."
        canonical="/"
        jsonLd={organizationSchema}
      />
      <Header toggleTheme={toggleTheme} />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <BottomNav />
      <NewsletterPopover />
    </div>
  );
}

export default Layout;
